import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/kinekt-new/transform-cta-back.webp";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Transformbuildcta() {
  return (
    <section className="transform-build-cta p-100 text_white">
      <Container>
        <div
          className="transform-build-box"
          style={{ backgroundImage: `url(${BgImg})` }}
        >
          <Row>
            <Col
              xs={12}
              md={6}
              lg={5}
              xl={5}
              xxl={5}
              className="order-2 order-md-1"
            >
              <div className="transform-mob-img">
                <StaticImage
                  src="../../../images/case-studies/kinekt-new/transform-mob.webp"
                  alt="TekRevol"
                  className="d-none d-md-block"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={571}
                  height={847}
                />
                <StaticImage
                  src="../../../images/case-studies/kinekt-new/transform-mob-view.webp"
                  alt="TekRevol"
                  className="d-block d-md-none"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={388}
                  height={774}
                />
              </div>
            </Col>
            <Col
              xs={12}
              md={6}
              lg={6}
              xl={6}
              xxl={6}
              className="my-auto offset-lg-1 order-1 order-md-2"
            >
              <h2 className="head-h2-kinekt">
                Let’s <span style={{ color: "#20A2BE" }}>Transform</span> Your{" "}
                <span style={{ color: "#20A2BE" }}>Healthcare</span> Platform
              </h2>
              <h3>
                Want to enhance patient engagement with AI-driven solutions?
                Let’s talk!
              </h3>
              <Link
                style={{
                  background: "#20A2BE",
                  color: "#fff",
                  border: "1px solid #20A2BE",
                }}
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Get in Touch
              </Link>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}

export default Transformbuildcta;
